// extracted by mini-css-extract-plugin
module.exports = {"giftcard":"GiftCard_giftcard__94QrG","giftcardimage":"GiftCard_giftcardimage__z2_dv","giftcardtext":"GiftCard_giftcardtext__9uSTK"};